<template lang="html">
<div class="loader-wrapper" :class="{'full-page' : fullPage}">
  <div class="shadow" v-if="fullPage"></div>
  <div class="circle">
    <div class="center-circle">
      <div class="satellite-circle"></div>
    </div>
    <div class="loader-content" v-if="message || canCancel">
      <p class="loader-message" v-if="message">{{ message }}</p>
      <button
        v-if="canCancel"
        class="button-cancel btn btn-danger"
        @click="cancel"
        type="button"
      >
        {{ $t('shared.actions.cancel') }}
      </button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    fullPage: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: '',
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$store.dispatch('cancelRequest');
    },
  },
};
</script>

<style lang="scss" scoped>

$blue-color: #00AEEF;
$grey-color: #58595B;
$text-color: #FFFFFF;
$circle-size: 50px;
$border-size: 5px;
$circle-margin: 0px;
$satellite-size: 0px;
$satellite-margin: -10px;
$satellite-transform: 30px;

$circle-size-sm: 25px;
$border-size-sm: 3px;
$satellite-margin-sm: -7px;
$satellite-transform-sm: 16px;

@keyframes spinner {
  to {transform: rotate(360deg);}
}

.loader-wrapper {
  min-width: 30px;
  min-height: 30px;
  .circle {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2001;
    .center-circle {
      position: absolute;
      width: $circle-size-sm;
      height: $circle-size-sm;
      border: $border-size-sm solid $grey-color;
      border-radius: 100%;
    }
    .satellite-circle {
      position: absolute;
      width: $satellite-size;
      height: $satellite-size;
      top: $satellite-margin-sm;
      left: $satellite-margin-sm;
      border: $border-size-sm solid $blue-color;
      border-radius: 100%;
      animation: spinner 2s linear infinite;
      transform-origin: $satellite-transform-sm $satellite-transform-sm;
    }
    .loader-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: calc(#{$circle-size} / 2 + 120px);
      z-index: 1;

      .loader-message {
        margin-bottom: 4px;
        color: $text-color;
        font-size: larger;
        font-weight: bold;
        text-shadow: 0 1px 2px rgba(0,0,0,0.35);
        text-align: center;
      }

      .button-cancel {
        min-width: 120px;
      }
    }
  }
}

.full-page {
  min-width: 100%;
  min-height: 100%;
  .shadow {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(123, 123, 123, 0.4);
    margin: 0;
    padding: 0;
    z-index: 2000;
    top: 0;
  }
  .circle {
    position: fixed;
    .center-circle {
      position: absolute;
      width: $circle-size;
      height: $circle-size;
      border: $border-size solid $grey-color;
      border-radius: 100%;
    }
    .satellite-circle {
      top: $satellite-margin;
      left: $satellite-margin;
      border: $border-size solid $blue-color;
      transform-origin: $satellite-transform $satellite-transform;
    }
  }
}

</style>
